define('views/lib/Podio.Views.ContentOverlay',['require','underscore','jquery','lib/backbone/Backbone.PodioView','lib/Podio.UI.Modal','jst!lib/_dynamic_content_overlay','jst!lib/_overlay_arrows','lib/Podio.Utils','bowser','lib/LayersEventManager','lib/Podio.UI.Tooltips'],function(require) {

  var _ = require('underscore');
  var $ = require('jquery');
  var PodioView = require('lib/backbone/Backbone.PodioView');
  var modal = require('lib/Podio.UI.Modal');
  var jstOverlay = require('jst!lib/_dynamic_content_overlay');
  var jstArrows = require('jst!lib/_overlay_arrows');
  var podioUtils = require('lib/Podio.Utils');
  var browser = require('bowser');
  var LayersEventManager = require('lib/LayersEventManager');

  var Tooltips = require('lib/Podio.UI.Tooltips');

  var view = PodioView.extend({
    podioEvents: {
      'click .close-overlay': 'onOverlayCloseClick',
      'click default .js-overlay-content-area': 'onOverlayClick',
      'click .arrow-left': 'onLeftArrowTriggered',
      'click .arrow-right': 'onRightArrowTriggered'
    },

    className: function() {
      var className = 'content-overlay {0}'.format(this.options.contentClassName);
      if (!browser.msie) {
        className += ' background-animate is-animated'; // `.is-animated` is the top-level flag for animation for non-IE.
      }
      if (browser.safari && browser.version < 10) {
        className += ' is-safari';
      }

      return className;
    },

    initialize: function(options) {
      this.contentClassName = options.contentClassName;
      this.elmBody = $('body');
      this._super();
    },

    render: function() {
      LayersEventManager.register(this, 'keydown', this.onKeydown.bind(this));
      this.elmBody.addClass('no-scroll');
      this.elm.html(this.getTemplate(jstOverlay));

      var reflow = this.elm.height(); //Trigger layout to start animation
      var self = this;
      _.defer(function() {
        self.elm.addClass('background');
      });

      return this;
    },

    renderContent: function(content) {
      this.elm.find('.body').html(content);
    },

    renderArrows: function() {
      // remove the old arrows, if present
      this.removeArrows();

      this.elm.find('.item-overlay-wrapper').append(this.getTemplate(jstArrows, { left: this.prevEnabled, right: this.nextEnabled }));
    },

    removeArrows: function() {
      this.elm.find('.arrow').remove();
    },

    displayLoaderOnArrow: function(direction) {
      var className = direction === 'next' ? 'right' : 'left';

      this.elm.find('.arrow-{0}'.format(className)).addClass('has-loader');
    },

    removeLoaderFromArrow: function(direction) {
      var className = direction === 'next' ? 'right' : 'left';

      this.elm.find('.arrow-{0}'.format(className)).removeClass('has-loader');
    },

    onOverlayCloseClick: function(e) {
      Tooltips.hideAll();
      this.trigger('overlayView:closed');
    },

    onOverlayClick: function(elmTarget, e) {
      if ($(e.target).is('.js-overlay-content-area')) {
        e.preventDefault();
        this.onOverlayCloseClick();
      }
    },

    onKeydown: function(event) {
      if (event.keyCode === 27) {
        event.stopPropagation();
        this.trigger('overlayView:closed');
      } else if (event.keyCode === 37) {
        event.stopPropagation();
        this.onLeftArrowTriggered();
      } else if (event.keyCode === 39) {
        event.stopPropagation();
        this.onRightArrowTriggered();
      }
    },

    updateNextPrevNavigation: function(options) {
      this.prevEnabled = options.enablePrev;
      this.nextEnabled = options.enableNext;

      if (this.prevEnabled || this.nextEnabled) {
        this.renderArrows();
      } else {
        this.removeArrows();
      }
    },

    onLeftArrowTriggered: function() {
      if (this.prevEnabled && !modal.isShowingModal()) {
        this.trigger('overlayView:prevTriggered');
      }
    },

    onRightArrowTriggered: function() {
      if (this.nextEnabled && !modal.isShowingModal()) {
        this.trigger('overlayView:nextTriggered');
      }
    },

    dispose: function() {
      LayersEventManager.unregister(this);
      this.elmBody.removeClass('no-scroll');

      this._super();
    }

  });

  _.extend(view.prototype);

  return view;

});

